
import './styles.css';
import InsaneTableNoHttp from '../../component/insane-table-no-http';
//////////// REDUX | STORE | SERVICE /////////////
import { useDispatch } from 'react-redux';
import { HttpRequest } from '../../service/HttpRequest';
import { showLoad, dismissLoad } from '../../store/slice/loading';

import React from "react";

function MaintenanceDashboard() {

    const dispatch = useDispatch();

    const [contentNumber, switchContent] = React.useState(0);
    const [bodyReq, setBodyReq] = React.useState({ "startdate": null, "enddate": null });

    const [dataReq, setDataReq] = React.useState([]);
    const [dataReqFormcodeList, setDataReqFormcodeList] = React.useState([]);

    const [dataTable, setDataTable] = React.useState([]);
    const [dataTableFormcode, setDataTableFormcode] = React.useState([]);
    const [dataTableReportStatus, setDataTableReportStatus] = React.useState([]);
    // const [dataTableNextPerformer, setDataTableNextPerformer] = React.useState([]);

    const [filterStatus, setFilterStatus] = React.useState("");
    const [filterFormcode, setFilterFormcode] = React.useState("");
    const [filterReportStatus, setFilterReportStatus] = React.useState("NOTPROCESS");
    const [filterNextPerformer, setFilterNextPerformer] = React.useState("NOTPROCESS");

    const [headTitle, setHeadTitle] = React.useState("Dashboard - My Request");

    const tableOption = {
        tableName: "WorkOrders",
        className: "",
        mapTable: [
            {
                displayName: "Work order No",
                attName: "workorderno",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Work order desc",
                attName: "workorderdesc",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Equipment TagID",
                attName: "equipment_tagid",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Start date",
                attName: "startdate",
                type: "date",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Finish date",
                attName: "finishdate",
                type: "date",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Plant TagID",
                attName: "plant_tagid",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
        ],
        action: [
            // {
            //     name: "MT Result",
            //     mode: "page", /// page, modal, form
            //     option: {
            //         url: "/d-rec-admin/main/maintenance/result-mt/view"
            //     }
            // }
        ]
    }

    const tableOptionViewResult = {
        tableName: "WorkOrders",
        className: "",
        mapTable: [
            {
                displayName: "MT Result No",
                attName: "mtresultno",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Work order No",
                attName: "workorderno",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Formcode",
                attName: "formcode",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Logtime",
                attName: "logtime",
                type: "date",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Calibration Date",
                attName: "calibration_date",
                type: "date",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Note",
                attName: "note",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Status Workorder",
                attName: "status_workorder",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Status Tolerance",
                attName: "status_tolerance",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Status Accept Workorder",
                attName: "status_accept_workorder",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Concern Person",
                attName: "concern_person",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Status Approve",
                attName: "status_approve",
                type: "status-approve",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Remark",
                attName: "approve_remark",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            }
        ],
        api: {
            approve: {
                enable: true,
                url: "/admin/mt/mtresult/approve",
                dataReq: {
                    "mtresultno": "",
                    "remark": ""
                }
            },
            reject: {
                enable: true,
                url: "/admin/mt/mtresult/reject",
                dataReq: {
                    "mtresultno": "",
                    "remark": ""
                }
            }
        },
        action: [
            {
                name: "Approve",
                mode: "modal-form-action", /// page, modal, form
                option: {
                    type: "approve"
                }
            },
            {
                name: "Reject",
                mode: "modal-form-action", /// page, modal, form
                option: {
                    type: "reject"
                }
            },
            {
                name: "view",
                mode: "page", /// page, modal, form
                option: {
                    url: "/d-rec-admin/main/maintenance/dashboard/workorder",
                    enable_by: "mtresultno"
                }
            }
        ]
    }

    async function onRequest(state = "") {
        dispatch(showLoad());

        setDataReq([]);
        setDataTable([]);

        let body = (state === "clear") ? { startdate: null, enddate: null, } : bodyReq;


        await HttpRequest("/admin/mt/workorder/get", body).then(data => {

                // console.log("/admin/mt/workorder/get --->",  data);
            if (data.result === "OK") {
                let att_name = Object.keys(data);
                let result = data[att_name[1]];
                // console.log(result);
                setDataReq(result);
                setDataTable(result);

                let _dataTable_filter_attach = result.filter((x) => ((x.attachequipment) && (x.attachmtresult)));

                let _dataTable_filter_formcode = result.filter((x) => (x.attach_formcode === filterFormcode));
                let group_dataTable_formcode = groupWorkOrderByEquipmentTagid(_dataTable_filter_formcode);
                setDataTableFormcode(group_dataTable_formcode)

                let _dataTable_filter_status = _dataTable_filter_attach.filter((x) => (x.status === filterReportStatus));
                let group_dataTable_report_status = groupWorkOrderByEquipmentTagid(_dataTable_filter_status);
                setDataTableReportStatus(group_dataTable_report_status);
                // console.log("dataTableReportStatus --->", dataTableReportStatus);
            }

        });

        await HttpRequest("/admin/mt/form/get", {}).then(data => {

            if (data.result === "OK") {
                let att_name = Object.keys(data);
                let result = data[att_name[1]];

                result.sort(function (a, b) {
                    let A = a.formname;
                    let B = b.formname;
                    if (A < B) { return -1 }
                    if (A > B) { return 1 }
                    return 0;
                });

                setDataReqFormcodeList(result);
                // console.log("dataReqFormcodeList ---> ", dataReqFormcodeList);
                setFilterFormcode(result[0].formcode);
            }

        });

        dispatch(dismissLoad());
        // console.log("dataReq --> ", dataReq);
    }

    function groupWorkOrderByEquipmentTagid(_dataTable_filter) {
        let groupWorkOrder = {};
        for (let i = 0; i < _dataTable_filter.length; i++) {
            if (groupWorkOrder[_dataTable_filter[i].equipment_tagid]) {
                groupWorkOrder[_dataTable_filter[i].equipment_tagid].push(_dataTable_filter[i]);
            } else {
                groupWorkOrder[_dataTable_filter[i].equipment_tagid] = [_dataTable_filter[i]];
            }
        }
        return groupWorkOrder;
    }

    function countByStatus(status) {
        let dataReqFiltered = dataReq.filter((_data) => _data.status === status);
        return dataReqFiltered.length
    }


    React.useEffect(() => {
        const controller = new AbortController();

        onRequest();

        return () => { controller.abort() };
    }, []);// eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
        const controller = new AbortController();

        if (filterStatus !== "") {
            let dataReqFiltered = dataReq.filter((_data) => _data.status === filterStatus);
            setDataTable(dataReqFiltered);
        } else {
            setDataTable(dataReq);
        }

        return () => { controller.abort() };
    }, [filterStatus]);// eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
        const controller = new AbortController();

        // let _dataTable_filter_attach = dataReq.filter((x) => ((x.attachequipment) && (x.attachmtresult)));
        // let _dataTable_filter_formcode = _dataTable_filter_attach.filter((x) => (x.attachequipment.formcode === filterFormcode));
        let _dataTable_filter_formcode = dataReq.filter((x) => (x.attach_formcode === filterFormcode));
        let group_dataTable_formcode = groupWorkOrderByEquipmentTagid(_dataTable_filter_formcode);
        setDataTableFormcode(group_dataTable_formcode);

        return () => { controller.abort() };
    }, [filterFormcode]);// eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
        const controller = new AbortController();

        let _dataTable_filter_attach = dataReq.filter((x) => ((x.attachequipment) && (x.attachmtresult)));
        let _dataTable_filter_status = _dataTable_filter_attach.filter((x) => (x.status === filterReportStatus));
        let group_dataTable_report_status = groupWorkOrderByEquipmentTagid(_dataTable_filter_status);
        setDataTableReportStatus(group_dataTable_report_status);

        return () => { controller.abort() };
    }, [filterReportStatus]);// eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className='content'>
            <div className='content-dashboard'>

                <div className='menu'>
                    <div className='list-toppic'>Dashboard</div>
                    <button
                        className={'list ' + (contentNumber === 0 ? "active" : "")}
                        onClick={() => { switchContent(0); setHeadTitle("Dashboard - My Request"); }}>
                        {contentNumber === 0 ? <div className='active'></div> : null} My Request
                    </button>
                    <div className='list-toppic'>All request</div>
                    <button
                        className={'list ' + (contentNumber === 1 ? "active" : "")}
                        onClick={() => { switchContent(1); setHeadTitle(("By Equipment type - " + filterFormcode)); }}>
                        {contentNumber === 1 ? <div className='active'></div> : null} By Equipment type
                    </button>
                    {
                        contentNumber === 1 ?
                            <div className='sub-list-box'>
                                {
                                    dataReqFormcodeList.map((row, i) => (
                                        <div
                                            key={i}
                                            className={'sub-list ' + ((filterFormcode === row.formcode) ? "active" : "")}
                                            onClick={() => { setFilterFormcode(row.formcode); setHeadTitle(("By Equipment type - " + row.formcode)); }}>
                                            {row.formname}
                                        </div>
                                    ))
                                }

                                <div
                                    className={'sub-list ' + ((filterFormcode === "UNKNOWN") ? "active" : "")}
                                    onClick={() => { setFilterFormcode("UNKNOWN"); setHeadTitle(("By Equipment type - UNKNOWN")); }}>
                                    UNKNOWN
                                </div>
                            </div> : null
                    }
                    <button
                        className={'list ' + (contentNumber === 2 ? "active" : "")}
                        onClick={() => { switchContent(2); setHeadTitle("Draft") }}>
                        {contentNumber === 2 ? <div className='active'></div> : null} By Report status
                    </button>
                    {
                        contentNumber === 2 ?
                            <div className='sub-list-box'>
                                <div
                                    className={'sub-list ' + ((filterReportStatus === "NOTPROCESS") ? "active" : "")}
                                    onClick={() => { setFilterReportStatus("NOTPROCESS"); setHeadTitle("Draft") }}>
                                    Draft
                                </div>
                                <div
                                    className={'sub-list ' + ((filterReportStatus === "INPROCESS") ? "active" : "")}
                                    onClick={() => { setFilterReportStatus("INPROCESS"); setHeadTitle("Wait for section mgr. approve") }}>
                                    Wait for section mgr. approve</div>
                                <div
                                    className={'sub-list ' + ((filterReportStatus === "REJECT") ? "active" : "")}
                                    onClick={() => { setFilterReportStatus("REJECT"); setHeadTitle("Section mgr. reject") }}>
                                    Section mgr. reject
                                </div>
                                <div
                                    className={'sub-list ' + ((filterReportStatus === "APPROVE") ? "active" : "")}
                                    onClick={() => { setFilterReportStatus("APPROVE"); setHeadTitle("Completed") }}>
                                    Completed
                                </div>
                            </div> : null
                    }
                    <button
                        className={'list ' + (contentNumber === 3 ? "active" : "")}
                        onClick={() => { switchContent(3); setHeadTitle("Draft") }}>
                        {contentNumber === 3 ? <div className='active'></div> : null} By Next performer
                    </button>
                    {
                        contentNumber === 3 ?
                            <div className='sub-list-box'>
                                <div
                                    className={'sub-list ' + ((filterNextPerformer === "NOTPROCESS") ? "active" : "")}
                                    onClick={() => { setFilterNextPerformer("NOTPROCESS"); setHeadTitle("Draft") }}>
                                    Draft
                                </div>
                                <div
                                    className={'sub-list ' + ((filterNextPerformer === "INPROCESS") ? "active" : "")}
                                    onClick={() => { setFilterNextPerformer("INPROCESS"); setHeadTitle("Wait for section mgr. approve") }}>
                                    Wait for section mgr. approve</div>
                                <div
                                    className={'sub-list ' + ((filterNextPerformer === "REJECT") ? "active" : "")}
                                    onClick={() => { setFilterNextPerformer("REJECT"); setHeadTitle("Section mgr. reject") }}>
                                    Section mgr. reject
                                </div>
                                <div
                                    className={'sub-list ' + ((filterNextPerformer === "APPROVE") ? "active" : "")}
                                    onClick={() => { setFilterNextPerformer("APPROVE"); setHeadTitle("Completed") }}>
                                    Completed
                                </div>
                            </div> : null
                    }
                    <button
                        className={'list ' + (contentNumber === 4 ? "active" : "")}
                        onClick={() => { switchContent(4); setHeadTitle("Work remaining from SAP") }}>
                        {contentNumber === 4 ? <div className='active'></div> : null} Work remaining from SAP
                    </button>
                    {
                        contentNumber === 4 ?
                            <div className='sub-list-box'>
                                <div className='sub-list'>PM</div>
                                <div className='sub-list'>CM</div>
                            </div> : null
                    }
                    {/* <button className={'list ' + (contentNumber === 5 ? "active" : "")} onClick={() => { switchContent(5); }}>
                        {contentNumber === 5 ? <div className='active'></div> : null} EQ. tag set up
                    </button>
                    <button className={'list ' + (contentNumber === 6 ? "active" : "")} onClick={() => { switchContent(6); }}>
                        {contentNumber === 6 ? <div className='active'></div> : null} STD gas/Reference
                    </button> */}
                </div>
                <div className='main' style={{ padding: 15, height: "93%" }}>
                    <div className="header-box">
                        <span className="title">{headTitle}</span>
                        <div className="box-input">
                            <span>Start Date</span>
                            <input
                                className="custom-input"
                                type="date"
                                // value={bodyReq.startdate}
                                onChange={(e) => {
                                    let _option = { ...bodyReq };
                                    if (e.target.value) {
                                        _option.startdate = (new Date(e.target.value)).toISOString();
                                    } else {
                                        _option.startdate = null;
                                    }
                                    setBodyReq(_option);
                                }} />
                        </div>
                        <div className="box-input">
                            <span>End Date</span>
                            <input
                                className="custom-input"
                                type="date"
                                // value={bodyReq.enddate}
                                onChange={(e) => {
                                    let _option = { ...bodyReq };
                                    if (e.target.value) {
                                        _option.enddate = (new Date(e.target.value)).toISOString();
                                    } else {
                                        _option.enddate = null;
                                    }
                                    setBodyReq(_option);
                                }} />
                        </div>

                        <button className="custom-input"
                            onClick={() => { onRequest('clear'); }}>Clear Date filter</button>
                        <button className="custom-input bt_search"
                            onClick={() => { onRequest(); }}>Search</button>
                    </div>
                    {
                        (contentNumber === 0) ? (
                            <div className='main' style={{ marginLeft: -15, marginRight: -15, padding: 15 }}>
                                <div className='head-content-page'>

                                    <div className={'box-summary total ' + (filterStatus === "" ? "active" : "")} onClick={() => setFilterStatus("")}>
                                        <div className='value'>{dataReq.length}</div>
                                        <div className='toppic'>Total Work Order</div>
                                    </div>
                                    <div className={'box-summary wait ' + (filterStatus === "NOTPROCESS" ? "active" : "")} onClick={() => setFilterStatus("NOTPROCESS")}>
                                        <div className='value'>{countByStatus("NOTPROCESS")}</div>
                                        <div className='toppic'>Waiting for your action</div>
                                    </div>
                                    <div className={'box-summary process ' + (filterStatus === "INPROCESS" ? "active" : "")} onClick={() => setFilterStatus("INPROCESS")}>
                                        <div className='value'>{countByStatus("INPROCESS")}</div>
                                        <div className='toppic'>Processing document</div>
                                    </div>
                                    <div className={'box-summary success ' + (filterStatus === "APPROVE" ? "active" : "")} onClick={() => setFilterStatus("APPROVE")}>
                                        <div className='value'>{countByStatus("APPROVE")}</div>
                                        <div className='toppic'>Completed Document</div>
                                    </div>
                                </div>
                                <InsaneTableNoHttp
                                    className='insane-table-dashboard'
                                    option={tableOption}
                                    dataTable={dataTable}
                                    limitRow={10}></InsaneTableNoHttp>
                            </div>
                        ) : (null)
                    }
                    {
                        (contentNumber === 1) ? (
                            <div className='main' style={{ marginLeft: -15, marginRight: -15 }}>
                                {
                                    Object.keys(dataTableFormcode).map((key, i) => {
                                        let dataTableFormcode_dataTable = [];
                                        for (let j = 0; j < dataTableFormcode[key].length; j++) {
                                            if (dataTableFormcode[key][j].attachmtresult) {
                                                let data_row = { 
                                                    ...dataTableFormcode[key][j].attachmtresult
                                                    , attachequipment: dataTableFormcode[key][j].attachequipment
                                                }
                                                dataTableFormcode_dataTable.push(data_row);
                                            }
                                        }
                                        return (
                                            <div key={i} style={{ display: "flex", flexDirection: "column" }}>
                                                <div style={{ 
                                                    paddingLeft: 25,
                                                    paddingRight: 15,
                                                    background: "#EEE",
                                                    fontSize: 20,
                                                    fontWeight: "bolder"
                                                }}>{key}</div>

                                                <InsaneTableNoHttp
                                                    className={key}
                                                    option={tableOptionViewResult}
                                                    dataTable={dataTableFormcode_dataTable}
                                                    reload={onRequest}
                                                    limitRow={5}></InsaneTableNoHttp>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        ) : (null)
                    }
                    {
                        (contentNumber === 2) ? (
                            <div className='main' style={{ marginLeft: -15, marginRight: -15 }}>
                                {
                                    Object.keys(dataTableReportStatus).map((key, i) => {
                                        let dataTableReportStatus_dataTable = [];
                                        for (let j = 0; j < dataTableReportStatus[key].length; j++) {
                                            
                                            if (dataTableReportStatus[key][j].attachmtresult) {
                                                let data_row = { 
                                                    ...dataTableReportStatus[key][j].attachmtresult
                                                    , attachequipment: dataTableReportStatus[key][j].attachequipment
                                                }
                                                dataTableReportStatus_dataTable.push(data_row);
                                            }
                                        }
                                        // console.log("dataTableReportStatus_dataTable " + key + " ---> ", dataTableReportStatus_dataTable);
                                        return (
                                            <div key={i} style={{ display: "flex", flexDirection: "column" }}>
                                                <div style={{ paddingLeft: 25, paddingRight: 15, background: "#EEE", fontSize: 20, fontWeight: "bolder" }}>{key}</div>
                                                <InsaneTableNoHttp
                                                    className={key}
                                                    option={tableOptionViewResult}
                                                    dataTable={dataTableReportStatus_dataTable}
                                                    reload={onRequest}
                                                    limitRow={5}></InsaneTableNoHttp>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        ) : (null)
                    }
                    {
                        (contentNumber === 3) ? (
                            <div className='main'>
                                By Next performer
                            </div>
                        ) : (null)
                    }
                    {
                        (contentNumber === 4) ? (
                            <div className='main'>
                                Work remaining from SAP
                            </div>
                        ) : (null)
                    }
                    {/* {
                        (contentNumber === 5) ? (
                            <div className='main'>
                                EQ. tag set up
                            </div>
                        ) : (null)
                    }
                    {
                        (contentNumber === 6) ? (
                            <div className='main'>
                                STD gas/Reference
                            </div>
                        ) : (null)
                    } */}
                </div>
            </div>

        </div>
    );
}

export default MaintenanceDashboard;